import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/login');
}



// WEBPACK FOOTER //
// ./src/portal/states/public/default/default.state.js